var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 16.25H35.3571V55.25C35.3571 56.1302 35.0391 56.8919 34.4029 57.5352C33.7667 58.1784 33.0134 58.5 32.1429 58.5V87.75C32.1429 88.6302 31.8248 89.3919 31.1886 90.0352C30.5525 90.6784 29.7991 91 28.9286 91H3.21429C2.34375 91 1.5904 90.6784 0.954241 90.0352C0.31808 89.3919 0 88.6302 0 87.75V61.75L12.5056 17.418C12.74 16.6393 13.2589 16.25 14.0625 16.25ZM38.5714 16.25H51.4286V52H38.5714V16.25ZM77.4944 17.418L90 61.75V87.75C90 88.6302 89.6819 89.3919 89.0458 90.0352C88.4096 90.6784 87.6563 91 86.7857 91H61.0714C60.2009 91 59.4475 90.6784 58.8114 90.0352C58.1752 89.3919 57.8571 88.6302 57.8571 87.75V58.5C56.9866 58.5 56.2333 58.1784 55.5971 57.5352C54.9609 56.8919 54.6429 56.1302 54.6429 55.25V16.25H75.9375C76.7411 16.25 77.26 16.6393 77.4944 17.418ZM36.5123 0.457031C36.8136 0.761719 36.9643 1.15104 36.9643 1.625V13H19.2857V1.625C19.2857 1.15104 19.4364 0.761719 19.7377 0.457031C20.0391 0.152344 20.4241 0 20.8929 0H35.3571C35.8259 0 36.2109 0.152344 36.5123 0.457031ZM70.2623 0.457031C70.5636 0.761719 70.7143 1.15104 70.7143 1.625V13H53.0357V1.625C53.0357 1.15104 53.1864 0.761719 53.4877 0.457031C53.7891 0.152344 54.1741 0 54.6429 0H69.1071C69.5759 0 69.9609 0.152344 70.2623 0.457031Z",
    fill: "#5AA048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.952fcb5b3a4d87449ee4e6fe24d47302.svg";
export { ForwardRef as ReactComponent };